module.exports = __webpack_public_path__ + "img/dropdownEle.8fdb10ef.svg";